export default __webpack_public_path__ + "static/media/newLogo.2b1feb81.png";